import { Ethnicity } from '~/services/api/enums';

const ethnicityOptions = [
  {
    value: null,
    label: '--None--',
  },
  {
    value: Ethnicity.AfricanAmericanBlack,
    label: 'African American/Black',
  },
  {
    value: Ethnicity.Asian,
    label: 'Asian',
  },
  {
    value: Ethnicity.CaucasianWhite,
    label: 'Caucasian/White',
  },
  {
    value: Ethnicity.HispanicLatino,
    label: 'Hispanic/Latino',
  },
  {
    value: Ethnicity.Others,
    label: 'Others',
  },
];

export default ethnicityOptions;
